import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/admin"); return; }
    (async () => {
      try {
        const res = await axios.post(`${API}/auth/session`, {}, {
          headers: { "X-Session-ID": sessionId },
          withCredentials: true,
        });
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: res.data } });
      } catch (e) {
        const msg = e?.response?.status === 403
          ? "This Google account is not authorized for Revive admin access."
          : "Sign-in failed. Please try again.";
        setError(msg);
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-navy grid place-items-center px-6 text-center">
      {error ? (
        <div className="max-w-sm">
          <p className="font-serif text-2xl text-champagne">{error}</p>
          <button onClick={() => navigate("/admin")}
            className="mt-6 rounded-full bg-white text-navy px-6 py-3 font-medium" data-testid="auth-error-back">
            Back to sign in
          </button>
        </div>
      ) : (
        <p className="font-sans text-white/70 tracking-wide" data-testid="auth-processing">Signing you in…</p>
      )}
    </div>
  );
};

export default AuthCallback;
